import { gql } from '@graphql/__generated__';

export const GET_ENQUIRIES_LIST = gql(/* GraphQL */ `
  query GetEnquiriesList(
    $where: enquiries_bool_exp!
    $order_by: [enquiries_order_by!]
    $limit: Int!
    $offset: Int!
  ) {
    enquiries(
      where: $where
      order_by: $order_by
      limit: $limit
      offset: $offset
    ) {
      id
      created_at
      updated_at
      processed
      first_name
      last_name
      email_address
      portal {
        name
      }
      lot {
        id
        ...ListingCell_listing
        broker {
          id
          ...UserInfo_user
        }
      }
      user {
        id
        ...UserInfo_user
      }
      broker {
        id
        ...UserInfo_user
      }
      team {
        id
        name
      }
    }
  }
`);

export const GET_ENQUIRIES_LIST_COUNT = gql(/* GraphQL */ `
  query GetEnquiriesListCount($where: enquiries_bool_exp!) {
    enquiries_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`);

export const GET_ENQUIRY_TYPE = gql(/* GraphQL */ `
  query GetEnquiryType($id: uuid!) {
    enquiries_by_pk(id: $id) {
      id
      broker_id
      team_id
      buyer_lead_id
      created_at
    }
  }
`);

export const GET_ENQUIRY_CONTACT_REQUEST = gql(/* GraphQL */ `
  query GetEnquiryContactRequest($id: uuid!) {
    enquiries_by_pk(id: $id) {
      ...ContactRequestEnquiry
      broker {
        id
      }
      team {
        id
      }
      property_transaction {
        id
        property {
          id
        }
      }
    }
  }
`);

export const DELETE_ENQUIRY = gql(/* GraphQL */ `
  mutation DeleteEnquiry($id: uuid!) {
    delete_enquiries_by_pk(id: $id) {
      id
    }
  }
`);

export const UPDATE_ENQUIRY_RESPONSE_ACTIVITY = gql(/* GraphQL */ `
  mutation UpdateEnquiryResponseActivity(
    $enquiryId: uuid!
    $responseActivityId: uuid!
    $buyerLeadId: uuid!
    $buyerLeadStage: uuid
    $updateBuyerLeadStage: Boolean!
  ) {
    update_enquiries_by_pk(
      pk_columns: { id: $enquiryId }
      _set: { response_activity_id: $responseActivityId, processed: true }
    ) {
      id
      processed
      response_activity {
        id
        email_message {
          id
          status
          date
        }
      }
    }
    update_buyer_leads(
      where: {
        id: { _eq: $buyerLeadId }
        _or: [
          { stage_id: { _is_null: true } }
          { lead_stage: { status: { _eq: active } } }
        ]
      }
      _set: { stage_id: $buyerLeadStage }
    ) @include(if: $updateBuyerLeadStage) {
      returning {
        id
        stage_id
        lead_stage {
          id
          status
        }
      }
    }
    update_activities_by_pk(
      pk_columns: { id: $responseActivityId }
      _set: { buyer_lead_id: $buyerLeadId }
    ) {
      id
      buyer_lead_id
    }
  }
`);

export const GET_BROCHURE_SENT_STAGE = gql(/* GraphQL */ `
  query GetBrochureSentStage {
    lead_stages(
      where: {
        name: { _eq: "brochure_sent" }
        pipeline: { name: { _eq: "house_sales" } }
      }
    ) {
      id
    }
  }
`);

export type SendEmailResponse = {
  activities?: Array<{ id: string }>;
};

export const MARK_ENQUIRY_AS_PROCESSED = gql(/* GraphQL */ `
  mutation MarkEnquiryAsProcessed($id: uuid!) {
    update_enquiries_by_pk(pk_columns: { id: $id }, _set: { processed: true }) {
      id
      processed
    }
  }
`);
